var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('nav-menu'),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }